/* eslint-disable import/no-cycle */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from '@glu/dropdown-react';
import { createUseStyles } from '@glu/theming';
import get from 'lodash/get';
import LocaleContext from '../../locale/LocaleContext';

import { getChargesOptions } from '../../createPayment/CreatePayment.dropdowns';
import { getPaymentType } from '../../createPayment/CreatePayment.utils';
import { PAYMENT_TYPES } from '../../../constants';

const styles = () => ({
  charges: {
    margin: 0,
    '& > label, & div[data-qa=dropdown-position]': {
      width: '100%',
      margin: 0
    }
  }
});

const useStyles = createUseStyles(styles);

const ChargesComponent = ({ data, formState, isTemplate }) => {
  const locale = useContext(LocaleContext);
  const classes = useStyles();

  const domestic =
    get(
      formState,
      'paymentType[0].type',
      getPaymentType(formState, data.paymentTypeOptions, { template: isTemplate })
    ) === PAYMENT_TYPES.WIRE.DOMESTIC;

  if (domestic) {
    return null;
  }

  const getDefaultName = (options, id) => {
    const optionId = Array.isArray(id) ? id[0] : id;
    // check if default value in dropdown is object - 2 scenario : with preload fields is it but for create payment is not.
    const getId = typeof optionId === 'object' ? optionId.id : optionId;
    const defVal = options.find((x) => x.id === getId);
    return get(defVal, 'name');
  };

  const options = getChargesOptions();

  let defaultValue = formState && formState?.charges;
  if (typeof defaultValue === 'string')
    defaultValue = [options?.find((option) => option.id === defaultValue)];
  else defaultValue = [options?.find((option) => option.id === 'BEN')];

  const props = {
    key: 'charges',
    name: 'charges',
    id: 'charges',
    dataQa: 'charges',
    htmlId: 'charges',
    labelText: locale['create.payment.charges'],
    format: (data) => getDefaultName(options, data),
    defaultValue,
    options,
    validators: [{ required: true, msg: locale['validation.required'] }],
    placeholder: locale['common.select'],
    className: classes.charges,
    filterEnabled: false
  };

  return (
    <div className="col-xs-3">
      <Dropdown {...props} />
    </div>
  );
};

ChargesComponent.propTypes = {
  data: PropTypes.shape({}).isRequired,
  onChange: PropTypes.func.isRequired,
  formState: PropTypes.shape({}).isRequired,
  isTemplate: PropTypes.bool.isRequired
};

export default ChargesComponent;
